import React from 'react';
import { bowser } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Fuel station',
  synonyms: 'gas petrol',
  group: 'standardMarker',
  typeUrl: 'fuel-station',
  icon: {
    baseShape: bowser,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'fuelStationMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Fuel station',
      itemTitleFunction: (item) => (item && item.title) || 'Fuel station',
    },
    creationOptions: {
      menuText: 'Fuel station',
      newTitle: 'Fuel station',
      titlePlaceholder: 'Name of fuel station',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a fuel or gas station location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Fuel station',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
